import Header from "../Home/Header/Header";
import BreadCrumbs from "../BreadCrumbs";
import Hero from "./Hero/Hero";
import NabForMarriege from "./NabForMarriege/NabForMarriege";
import Open from "./Open/Open";
import Questions from "./Questions/Questions";

function Marriege() {
    return (
        <div>
            <Header/>
            <BreadCrumbs/>
            <Hero/>
            <NabForMarriege/>
            <Open/>
            <Questions/>
        </div>
    )
}

export default Marriege